export const ExamSheetConfigured = [
    'TAK',
    'NIE'
];